import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { Width } from 'src/app/interfaces/width';
import { WidthsProviderService } from 'src/app/providers/widths/widths.provider.service';

@Injectable({
  providedIn: 'root'
})
export class WidthsService extends ApiService<Width, WidthsProviderService> {
  private widthsProviderService = inject(WidthsProviderService);
  protected override get provider(): WidthsProviderService {
    return this.widthsProviderService;
  }
}
